import React from 'react';
import { Lock, ShieldCheck } from 'lucide-react';
import { SeverityMeter, SIGNAL_DISCLAIMER } from './SeverityMeter';
import { getPatternDefinition } from '../../../data/patternDefinitions';
import type { NormalizedPattern } from '../../../utils/scanReport';
interface DetectedPatternGridProps {
  patterns: NormalizedPattern[];
  /** Full-access reports show the conversation-specific description. */
  isUnlocked: boolean;
}
export function DetectedPatternGrid({
  patterns,
  isUnlocked
}: DetectedPatternGridProps) {
  if (patterns.length === 0) {
    return <section className="flex items-start gap-4 rounded-2xl border border-forensic-line bg-forensic-surface p-6" data-id="element-171" data-mp="1lerrfbjqtk5l">
        <ShieldCheck className="mt-0.5 shrink-0 text-emerald-400" size={20} aria-hidden="true" data-id="element-172" data-mp="1udd78yxtyl2o" />
        <div data-id="element-173" data-mp="4y5li5dnnn28">
          <h2 className="text-base font-semibold text-white" data-id="element-174" data-mp="4xnkywjymmoi">
            No significant patterns detected
          </h2>
          <p className="mt-1 text-sm text-forensic-muted" data-id="element-175" data-mp="43lnryttsc">
            The engine didn’t flag recurring manipulation patterns in this
            conversation.
          </p>
        </div>
      </section>;
  }
  return <section aria-labelledby="patterns-heading" data-id="element-176" data-mp="1ctfitm3plnm4">
      <div className="mb-5 flex flex-wrap items-end justify-between gap-x-6 gap-y-1" data-id="element-177" data-mp="1gu974gl2d4fj">
        <div data-id="element-178" data-mp="1llhj9kds33we">
          <h2 id="patterns-heading" className="text-lg font-semibold text-white sm:text-xl" data-id="element-179" data-mp="1lm10szzinq9w">
            Detected patterns
          </h2>
          <p className="mt-1 text-xs text-forensic-subtle" data-id="element-180" data-mp="1qk2gdaxqh7gm">{SIGNAL_DISCLAIMER}</p>
        </div>
        <span className="text-sm text-forensic-muted tabular-nums" data-id="element-181" data-mp="1vi407y2zhat5">
          {patterns.length} total
        </span>
      </div>
      <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-182" data-mp="20gnr8cwfpcsd">
        {patterns.map((pattern, idx) => <li key={`${pattern.type}-${idx}`} className="flex flex-col rounded-xl border border-forensic-line bg-forensic-card p-5" data-id="element-183" data-mp="650irnkmddti" data-mpi={idx}>
            <SeverityMeter severity={pattern.severity} data-id="element-184" data-mp="a8ezyhkao08j" />
            <h3 className="mt-3 text-[15px] font-semibold leading-snug text-white" data-id="element-185" data-mp="1dggh73hdrxl4">
              {pattern.type}
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-forensic-muted" data-id="element-186" data-mp="18jq2okl85a1t">
              {isUnlocked && pattern.description ? pattern.description : getPatternDefinition(pattern.type)}
            </p>
            {!isUnlocked && pattern.evidenceLocked && <p className="mt-auto inline-flex items-center gap-1.5 pt-4 text-xs text-forensic-subtle" data-id="element-187" data-mp="1wej8joxei6m3">
                <Lock size={12} className="text-forensic-crimson-soft" aria-hidden="true" data-id="element-188" data-mp="1rghob0o8o191" />
                Evidence locked
              </p>}
          </li>)}
      </ul>
    </section>;
}